export default function TeamPayslips() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Payslips Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
